export default {
  scenes: {
    settlingIntoRoutine: {
      beats: {
        morningCoffeeRuns: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliCafe'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "It's been a few days into the project, and Reina has unknowingly developed a small routine—grabbing coffee before heading to work. One morning, she runs into Eric at the café.",
              choices: [
                {
                  text: 'Join Him Casually',
                  next: {
                    scene: 'settlingIntoRoutine',
                    beat: 'joinCasually'
                  }
                },
                {
                  text: 'Offer to Pay for His Coffee',
                  next: {
                    scene: 'settlingIntoRoutine',
                    beat: 'offerToPay'
                  }
                }
              ]
            }
          ]
        },
        joinCasually: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "Looks like we've got the same idea. Mind if I sit?"
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: "Free country. As long as you don't judge my terrible coffee choices."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'settlingIntoRoutine',
            beat: 'unspokenHabits'
          }
        },
        offerToPay: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "Figured you could use a boost."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'surprised',
              text: "Huh. Are we at the coffee-bribery stage of friendship already?"
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'settlingIntoRoutine',
            beat: 'unspokenHabits'
          }
        },
        unspokenHabits: {
          events: [
            {
              type: 'showNarration',
              text: "What starts as a one-time coincidence turns into an unspoken routine—most mornings, they find each other here."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "I swear, if you ever order tea, I'll reconsider our friendship."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "Noted. Black coffee only, if it means keeping my spot."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'right'
            }
          ],
          next: {
            scene: 'teamDynamics',
            beat: 'brainstormingSession'
          }
        }
      }
    },
    teamDynamics: {
      beats: {
        brainstormingSession: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliOffice'
            },
            {
              type: 'showNarration',
              text: "During a brainstorming meeting, Reina and Eric are put in charge of leading the next phase of the project. Their easy back-and-forth is starting to be noticed by the others."
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "During a brainstorming meeting, Reina and Eric are put in charge of leading the next phase of the project. Their easy back-and-forth is starting to be noticed by the others.",
              choices: [
                {
                  text: 'Brush It Off Casually',
                  next: {
                    scene: 'teamDynamics',
                    beat: 'brushItOff'
                  }
                },
                {
                  text: 'Get Playfully Competitive',
                  next: {
                    scene: 'teamDynamics',
                    beat: 'getCompetitive'
                  }
                }
              ]
            }
          ]
        },
        brushItOff: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "You guys just wish you had our creative genius."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "Don't worry, we'll send you notes."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'right'
            }
          ],
          next: {
            scene: 'teamDynamics',
            beat: 'aSolidTeam'
          }
        },
        getCompetitive: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "If we pull this off, you owe us drinks."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "High stakes. I accept."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'right'
            }
          ],
          next: {
            scene: 'teamDynamics',
            beat: 'aSolidTeam'
          }
        },
        aSolidTeam: {
          events: [
            {
              type: 'showNarration',
              text: "Despite their differences, Reina and Eric work well together, balancing each other out. Their teamwork feels effortless now."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "Honestly, I think we make a good team."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: "Yeah. This is actually… fun."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'right'
            }
          ],
          next: {
            scene: 'aShiftInTheAir',
            beat: 'aLateWorkSession'
          }
        }
      }
    },
    aShiftInTheAir: {
      beats: {
        aLateWorkSession: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliOffice'
            },
            {
              type: 'showEffect',
              effect: 'overlay',
              overlayType: 'nightOverlay',
              opacity: 0.5
            },
            {
              type: 'showNarration',
              text: "One night, Reina stays late at the office to finish something. To her surprise, Eric is still there too."
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "One night, Reina stays late at the office to finish something. To her surprise, Eric is still there too.",
              choices: [
                {
                  text: 'Casually Acknowledge It',
                  next: {
                    scene: 'aShiftInTheAir',
                    beat: 'casuallyAcknowledge'
                  }
                },
                {
                  text: 'Suggest Taking a Break',
                  next: {
                    scene: 'aShiftInTheAir',
                    beat: 'suggestBreak'
                  }
                }
              ]
            }
          ]
        },
        casuallyAcknowledge: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "You here to make sure I don't break anything?"
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "Thought that was my job."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'aShiftInTheAir',
            beat: 'aQuietRealization'
          }
        },
        suggestBreak: {
          events: [
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'left'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "We've been at this for hours. Want to grab some air?"
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'surprised',
              text: "That might actually be the best idea you've had today."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'center'
            }
          ],
          next: {
            scene: 'aShiftInTheAir',
            beat: 'aQuietRealization'
          }
        },
        aQuietRealization: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBeach'
            },
            {
              type: 'showEffect',
              effect: 'overlay',
              overlayType: 'nightOverlay',
              opacity: 0.7
            },
            {
              type: 'showNarration',
              text: "Sitting outside under the warm night sky, there's a pause in their usual banter. For the first time, the silence between them feels… different."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'thinking',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'neutral',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'thinking',
              text: "Hard to believe this will all be over in a few weeks."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'neutral',
              text: "Yeah. Time moves weird here."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'right'
            },
            {
              type: 'hideEffect',
              effect: 'overlay',
              overlayType: 'nightOverlay'
            }
          ],
          next: {
            scene: 'crossingUnseenLines',
            beat: 'aPersonalMoment'
          }
        }
      }
    },
    crossingUnseenLines: {
      beats: {
        aPersonalMoment: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliVilla'
            },
            {
              type: 'showNarration',
              text: "The next morning, Reina wakes up to find a message from Eric—it's just a simple link to a local spot he found, with no explanation."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'neutral',
              position: 'center'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "The next morning, Reina wakes up to find a message from Eric—it's just a simple link to a local spot he found, with no explanation.",
              choices: [
                {
                  text: 'Playfully Call Him Out',
                  next: {
                    scene: 'crossingUnseenLines',
                    beat: 'playfullyCallOut'
                  }
                },
                {
                  text: 'Just Show Up',
                  next: {
                    scene: 'crossingUnseenLines',
                    beat: 'justShowUp'
                  }
                }
              ]
            }
          ]
        },
        playfullyCallOut: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "Is this your way of forcing me to go outside?"
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "You caught me. I take my friendship responsibilities very seriously."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'center'
            }
          ],
          next: {
            scene: 'crossingUnseenLines',
            beat: 'aDayOffTogether'
          }
        },
        justShowUp: {
          events: [
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'neutral',
              text: "Be there in 10."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'surprised',
              text: "Didn't even need convincing. I'm impressed."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'center'
            }
          ],
          next: {
            scene: 'crossingUnseenLines',
            beat: 'aDayOffTogether'
          }
        },
        aDayOffTogether: {
          events: [
            {
              type: 'showLocation',
              locationId: 'baliBeach'
            },
            {
              type: 'showNarration',
              text: "Reina and Eric spend the day exploring—no work, no pressure, just enjoying Bali. It feels like the start of something… but neither of them acknowledges it yet."
            },
            {
              type: 'showCharacter',
              characterId: 'reina',
              variation: 'happy',
              position: 'left'
            },
            {
              type: 'showCharacter',
              characterId: 'eric',
              variation: 'happy',
              position: 'right'
            },
            {
              type: 'showDialog',
              speaker: 'reina',
              variation: 'happy',
              text: "If work was like this every day, I'd never leave."
            },
            {
              type: 'showDialog',
              speaker: 'eric',
              variation: 'happy',
              text: "So don't. Stay forever."
            },
            {
              type: 'showNarration',
              text: "He says it lightly, but something lingers in the air afterward."
            },
            {
              type: 'hideCharacter',
              characterId: 'reina',
              position: 'left'
            },
            {
              type: 'hideCharacter',
              characterId: 'eric',
              position: 'right'
            }
          ],
          goToChapter: {
            chapter: 'chapter3'
          }
        }
      }
    }
  }
}
